import { useGetAccountEventsQuery } from "@apis/accounts/useAccounts"
import { useGetProspectEventsQuery } from "@apis/prospects/useProspects"

export const EVENT_TYPE_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Cases", value: "cases" },
  { label: "Automated", value: "auto" },
  { label: "MX Contact and Notes", value: "mx" },
  { label: "Plan Changes", value: "plan" },
  { label: "Web Events", value: "web" },
] as const

export const useEventsSerializer = (
  prospect_guid: string | undefined,
  account_id: string | undefined,
  eventType: "account" | "prospect",
): ReturnType<
  typeof useGetProspectEventsQuery | typeof useGetAccountEventsQuery
> => {
  const getAccountEvents = useGetAccountEventsQuery(
    prospect_guid,
    account_id,
    eventType === "account",
  )
  const getProspectEvents = useGetProspectEventsQuery(
    prospect_guid,
    eventType === "prospect",
  )

  return eventType === "account" ? getAccountEvents : getProspectEvents
}
